export const setThrottled = (retryAfter, path) => ({
  type: 'SET_THROTTLED',
  retryAfter,
  path
});

export const clearThrottled = () => ({
  type: 'CLEAR_THROTTLED'
});
